module.exports = __webpack_public_path__ + "img/chuanmeiku.ee780ba7.svg";